<template>
    <li :class="listItemCssClasses" @click.prevent.stop="$emit('sort', header)">{{ header.title }}</li>
</template>

<script>
export default {
    props: ["header", "currentSort"],
    computed: {
        isCurrentSort() {
            return this.header.key === this.currentSort;
        },
        listItemCssClasses() {
            if (this.isCurrentSort) {
                return "is-current-sort";
            }

            return null;
        }
    }
};
</script>

